/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-department-item.reducer';

export const LabDepartmentItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labDepartmentItemEntity = useAppSelector(state => state.labDepartmentItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labDepartmentItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labDepartmentItem.detail.title">LabDepartmentItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labDepartmentItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{labDepartmentItemEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labDepartmentItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{labDepartmentItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.labDepartmentItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{labDepartmentItemEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labDepartmentItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labDepartmentItemEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.labDepartmentItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{labDepartmentItemEntity.timestampEntry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labDepartmentItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labDepartmentItemEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labDepartmentItem.lcTestItem">Lc Test Item</Translate>
          </dt>
          <dd>{labDepartmentItemEntity.lcTestItem ? labDepartmentItemEntity.lcTestItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labDepartmentItem.department">Department</Translate>
          </dt>
          <dd>{labDepartmentItemEntity.department ? labDepartmentItemEntity.department.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lab-department-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-department-item/${labDepartmentItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabDepartmentItemDetail;
